module.exports = __webpack_public_path__ + "img/facebook-black.60a8be2b.svg";